module.exports = __webpack_public_path__ + "img/demo4.5218ff10.png";